import { useState } from 'react'

import type { CommonProps, Value } from './types'

const toSelectionValues = (props: Pick<CommonProps, 'selectType'>, value: CommonProps['value']) =>
  props.selectType === 'checkbox' && !value ? [] : value

export const useSelectionState = (
  props: Pick<CommonProps, 'selectType' | 'value' | 'onValueChange'>
) => {
  const [internalValues, setCurrentValues] = useState<Value | Value[] | undefined>(
    toSelectionValues(props, props.value)
  )
  const currentValues =
    props.value === undefined ? internalValues : toSelectionValues(props, props.value)

  const onOptionCheck = (newValue: Value) => {
    if (Array.isArray(currentValues)) {
      const newArray = [...currentValues]
      const index = newArray.indexOf(newValue)
      if (index >= 0) {
        newArray.splice(index, 1)
      } else {
        newArray.push(newValue)
      }
      setCurrentValues(newArray)
      if (typeof props.onValueChange === 'function') {
        props.onValueChange(newArray)
      }
    } else {
      throw new Error('Assertion: value type of checkbox must be an array')
    }
  }

  const getIsSelected = (optionValue: Value) =>
    Array.isArray(currentValues)
      ? currentValues.includes(optionValue)
      : currentValues === optionValue

  return { currentValues, setCurrentValues, onOptionCheck, getIsSelected }
}
